// src/services/salaryService.js
import api from './api'

export const salaryService = {
  // Get all salaries with optional filters
  getSalaries: async (filters = {}) => {
    try {
      console.log('getSalaries called with filters:', filters)
      const params = new URLSearchParams()
      
      // Add filters if provided
      if (filters.employee) params.append('employee', filters.employee)
      if (filters.branch) params.append('branch', filters.branch)
      if (filters.month) params.append('month', filters.month)
      if (filters.year) params.append('year', filters.year)
      if (filters.limit) params.append('limit', filters.limit)
      if (filters.page) params.append('page', filters.page)
      
      const queryString = params.toString()
      const url = queryString ? `/hr/salaries?${queryString}` : '/hr/salaries'
      
      console.log('Making API call to:', url)
      const response = await api.get(url)
      console.log('getSalaries raw response:', response)
      return response
    } catch (error) {
      console.error('Error fetching salaries:', error)
      throw error
    }
  },

  // Create a new salary
  createSalary: async (salaryData) => {
    try {
      const response = await api.post('/hr/salaries', salaryData)
      return response.data
    } catch (error) {
      console.error('Error creating salary:', error)
      throw error
    }
  },

  // Get a specific salary by ID
  getSalaryById: async (salaryId) => {
    try {
      const response = await api.get(`/hr/salaries/${salaryId}`)
      return response.data
    } catch (error) {
      console.error('Error fetching salary:', error)
      throw error
    }
  },

  // Update an existing salary
  updateSalary: async (salaryId, salaryData) => {
    try {
      const response = await api.patch(`/hr/salaries/${salaryId}`, salaryData)
      return response.data
    } catch (error) {
      console.error('Error updating salary:', error)
      throw error
    }
  },

  // Delete a salary
  deleteSalary: async (salaryId) => {
    try {
      const response = await api.delete(`/hr/salaries/${salaryId}`)
      return response.data
    } catch (error) {
      console.error('Error deleting salary:', error)
      throw error
    }
  },

  // Generate payslip preview (for preview before creating)
  generatePayslipPreview: async (employee, month) => {
    try {
      const requestData = { employee, month }
      console.log('Generating payslip preview with data:', requestData)
      
      const response = await api.post('/hr/salaries/generate', requestData)
      return response.data
    } catch (error) {
      console.error('Error generating payslip preview:', error)
      throw error
    }
  },

  // Generate salary for an employee for a specific month
  generateSalary: async (employeeId, month) => {
    try {
      const salaryData = {
        employee: employeeId,
        month: month
      }
      
      const response = await api.post('/hr/salaries', salaryData)
      return response.data
    } catch (error) {
      console.error('Error generating salary:', error)
      throw error
    }
  },

  // Bulk create salaries for multiple employees
  bulkCreateSalaries: async (salariesData) => {
    try {
      const response = await api.post('/hr/salaries/bulk', { salaries: salariesData })
      return response.data
    } catch (error) {
      console.error('Error bulk creating salaries:', error)
      throw error
    }
  },

  // Get salary statistics
  getSalaryStats: async (filters = {}) => {
    try {
      const params = new URLSearchParams()
      
      if (filters.month) params.append('month', filters.month)
      if (filters.year) params.append('year', filters.year)
      if (filters.branch) params.append('branch', filters.branch)
      
      const queryString = params.toString()
      const url = queryString ? `/hr/salaries/stats?${queryString}` : '/hr/salaries/stats'
      
      const response = await api.get(url)
      return response.data
    } catch (error) {
      console.error('Error fetching salary statistics:', error)
      throw error
    }
  },

  // Download payslip as PDF
  downloadPayslipPDF: async (salaryId) => {
    try {
      const response = await api.get(`/hr/salaries/${salaryId}/download`, {
        responseType: 'blob' // Important for handling binary data
      })
      return response
    } catch (error) {
      console.error('Error downloading payslip PDF:', error)
      throw error
    }
  }
}

export default salaryService